import { useTranslation } from 'react-i18next'

import { AvailableSpot } from '../../assets/icons/AvailableSpot'
import { BeachHut } from '../../assets/icons/BeachHut'
import { DeckChair } from '../../assets/icons/DeckChair'
import { Gazebo } from '../../assets/icons/Gazebo'
import { NotAvailableSpot } from '../../assets/icons/NotAvailableSpot'
import { Parking } from '../../assets/icons/Parking'
import { Umbrella } from '../../assets/icons/Umbrella'

const LEGEND_ITEMS: { icon: React.ReactNode; label: string }[] = [
  {
    icon: <Umbrella />,
    label: 'map.legend.umbrella',
  },
  {
    icon: <DeckChair />,
    label: 'map.legend.deckChair',
  },
  {
    icon: <Gazebo />,
    label: 'map.legend.gazebo',
  },
  {
    icon: <BeachHut />,
    label: 'map.legend.beachHut',
  },
  {
    icon: <Parking />,
    label: 'map.legend.parking',
  },
]

export const LegendContent = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className="mb-3 grid grid-cols-2 gap-2">
        {LEGEND_ITEMS.map((element) => (
          <div className="flex items-center gap-2" key={element.label}>
            {element.icon}
            <span>{t(element.label)}</span>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-2 border-t pt-3">
        <div className="flex items-center gap-2">
          <AvailableSpot />
          <span>{t('map.legend.available')}</span>
        </div>
        <div className="flex items-center gap-2">
          <NotAvailableSpot />
          <span>{t('map.legend.notAvailable')}</span>
        </div>
      </div>
    </>
  )
}
